import "./report.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import axios from "axios";
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";
import { useSelector } from "react-redux";

const FinanceReport = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");
  const [loading, setLoading] = useState(false); // Loading state

  const validateForm = () => {
    const errors = {};

    if (!startDate) errors.startDate = "Start Date is required.";
    if (!endDate) errors.endDate = "End Date is required.";
    if (!userIdRedux) errors.backEndError = "User ID is NULL. Please re-login.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleGenerateReport = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true); // Start loading

    try {
      const response = await axios.get(
        `${BASE_URL}/api/report/generateFinanceReport/${userIdRedux}/${startDate}/${endDate}`,
        { responseType: "blob" } // Handle binary response
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      // Create an anchor element and trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = "Finance_Report.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      if (response.status === 201) {
        setBackEndError(<font color="green">Success Generating Report</font>);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "There is no data to generate the report.";
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>Finance Report</h1>
        </div>
        <div className="bottom">
          <div style={{ display: "flex", gap: "16px" }}>
            <div style={{ flex: 3 }}>
              <InputLabel style={{ flex: 1 }}>Start Date</InputLabel>
              <FormControl
                style={{ flex: 2 }}
                margin="normal"
                error={Boolean(errors.startDate)}
              >
                <NepaliDatePicker
                  inputClassName="form-control"
                  value={startDate}
                  onChange={(value) => setStartDate(value)}
                  options={{ calenderLocale: "ne", valueLocale: "en" }}
                />
                {errors.startDate && (
                  <FormHelperText>{errors.startDate}</FormHelperText>
                )}
              </FormControl>
            </div>
            <div style={{ flex: 3 }}>
              <InputLabel style={{ flex: 1 }}>End Date</InputLabel>
              <FormControl
                style={{ flex: 2 }}
                margin="normal"
                error={Boolean(errors.endDate)}
              >
                <NepaliDatePicker
                  inputClassName="form-control"
                  value={endDate}
                  onChange={(value) => setEndDate(value)}
                  options={{ calenderLocale: "ne", valueLocale: "en" }}
                />
                {errors.endDate && (
                  <FormHelperText>{errors.endDate}</FormHelperText>
                )}
              </FormControl>
            </div>
            <label style={{ visibility: "hidden", flex: 6 }}></label>
          </div>

          {/* Button placed on a new line and made bigger */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={handleGenerateReport}
              variant="contained"
              color="primary"
              style={{
                borderRadius: "15px",
                width: "100%", // Takes full width
                fontSize: "18px", // Larger font size
                padding: "12px", // Larger padding
              }}
              disabled={loading} // Disable button while loading
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Generate Report"
              )}
            </Button>
          </div>

          <span className="error-message">{backEndError}</span>
        </div>
      </div>
    </div>
  );
};

export default FinanceReport;
